import { glass } from "../tokens/glass";
import { surface } from "../tokens/surface";
import { shapePill } from "../../shape";

/**
 * Spatial filter-flyout chip — drop-in replacement for getEditorFilterChipSx
 * in UploadFloor.js. Preserves shape (pill, py:1, px:1.25, flex:1), tap
 * scale, and idle/selected border + shadow language; swaps the brand-alpha
 * selected border for a neutral black-alpha rim so tenant color does not
 * leak into the editor filter UI.
 */
export function getSpatialFilterChipSx({ selected = false } = {}) {
  return {
    flex: 1,
    minWidth: 0,
    borderRadius: shapePill,
    py: 1,
    px: 1.25,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    WebkitTapHighlightColor: "transparent",
    transition: "transform 0.12s ease",
    "&:active": { transform: "scale(0.98)" },
    border: selected
      ? surface.chipSelectedBorder
      : glass.border,
    background: selected
      ? "rgba(252, 252, 255, 1)"
      : "rgba(252, 252, 255, 0.98)",
    boxShadow: selected
      ? glass.shadowFilterChipSelected
      : glass.shadowFilterChipIdle,
  };
}
